import { combineReducers } from "redux";
import filterReducer from "./filterReducer";
const reducers = combineReducers({
  filterR: filterReducer,
});
export default reducers;
